import PropTypes from 'prop-types';
import React from 'react';

import { PandoraTypes } from '../../constants/SourceTypes';

import AlbumRowItem from './AlbumRowItem';
import CatalogRowItem from './CatalogRowItem';
import PlaylistRowItem from './PlaylistRowItem';
import PodcastEpisodeRowItem from './PodcastEpisodeRowItem';
import PodcastProgramRowItem from './PodcastProgramRowItem';
import StationRowItem from './StationRowItem';
import TrackRowItem from './TrackRowItem';

/**
 * MixedRowItem determines which type-specific T3 grid item to render based
 * on pandoraType. Useful for mixed-type grids and when you just don't feel like
 * specifying which type-specific RowItem to use.
 *
 * See CatalogRowItem, lib/RowItem and the various type-specific RowItem
 * components for additional available props.
 *
 * If we don't have a pandoraType set we can assume we should render a blank item
 * which appears as a placeholder.
 */
class MixedRowItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
  };

  render() {
    const { pandoraType } = this.props;

    if (pandoraType === PandoraTypes.ALBUM) {
      return <AlbumRowItem {...this.props} />;
    } else if (pandoraType === PandoraTypes.SONG) {
      return <TrackRowItem {...this.props} />;
    } else if (pandoraType === PandoraTypes.PLAYLIST) {
      return <PlaylistRowItem {...this.props} />;
    } else if (pandoraType === PandoraTypes.STATION) {
      return <StationRowItem {...this.props} />;
    } else if (pandoraType === PandoraTypes.PODCAST) {
      return <PodcastProgramRowItem {...this.props} />;
    } else if (pandoraType === PandoraTypes.EPISODE) {
      return <PodcastEpisodeRowItem {...this.props} />;
    }
    return <CatalogRowItem {...this.props} blankItem={true} />;
  }
}

export default MixedRowItem;
